module.exports = __webpack_public_path__ + "image/PER_logo2.png";